define([
        'jQuery',
        'underscore',
        'library/fcse-component/optionsMixin',
        'library/fcse-compatibility/object',
        'clientComponents/map/map'
    ],
    function ($, _, OptionsMixin, Object, Map) {
        /**
         * @typedef {Object} PreflightResponseMeta
         * @property {Object} bounds
         * @property {Array} locations
         * @property {Object} center
         */
        /**
         * @typedef {Object} PreflightResponseEvent
         * @property {string} state
         * @property {PreflightResponseMeta} meta
         */
        /**
         * DynamicRegionMap component.
         * @param {jQuery|String} element
         * @param {MultiRequestHandler} requestHandler
         * @param {Object} options
         * @constructor
         */
        const DynamicRegionMap = function (element, requestHandler, options) {
            // default options
            const defaultOptions = {
                loadingClass: 'is-loading',
                contentSelector: '[data-fcse-role="map-region-content"]',
                preflightRoute: 'allt_frontend.map.places_preflight'
            };
            this.addOptions(defaultOptions, options || {});
            this.element = element;
            this._map = null;
            this._requestHandler = requestHandler;
            this._requestInProgress = false;
            this._currentId = null;
            this._productSearch = null;

            this._init(
                this.element.data('id'),
                this.element.data('map-product-search'),
                this.element.data('fallback-center'),
                ''
            );
        };

        DynamicRegionMap.prototype = $.extend(Object.create(OptionsMixin), Object.create(Map.prototype), {
            /**
             * Initializer
             * @param {String} id
             * @param {String} productSearch
             * @param {Object} defaultCenter
             * @param {String} country
             * @private
             */
            _init: function (id, productSearch, defaultCenter, country) {
                this._requestHandler.on('success', $.proxy(this._onPreflightRequestSuccess, this));
                this._requestHandler.on('cancel', $.proxy(this._onPreflightRequestCancel, this));

                if (!productSearch) {
                    return;
                }

                this._productSearch = productSearch;

                if (this._currentId !== id) {
                    this._currentId = id;
                    this._doPreflightRequest(id, country, defaultCenter);
                } else if (this._map) {
                    this._map.loadMarkers(this._productSearch);
                }
            },

            /**
             * Creates and inits Map component
             * @param {Object} bounds
             * @param {Array} locations
             * @param {Object} center
             * @param {Number} zoom
             * @private
             */
            _initMap: function (bounds, locations, center, zoom) {
                if (!this._map) {
                    const self = this;

                    this._map = new Map(this.element, this._requestHandler, {
                        placeDetailsRoute: 'allt_frontend.map.place_details',
                        placesRoute: 'allt_frontend.map.places',
                        mapContainerSelector: '[data-fcse-role="map-region-content"]',
                        detailInfoBoxFactory: function () {},
                        productSearch: this._productSearch,
                        mapOptions: {
                            mapTypeControl: false,
                            disableDefaultUI: true
                        }
                    });
                    this._map.on('mapCreated', function () {
                        self.element.show();
                        const debouncer = _.debounce($.proxy(self._onBoundsZoomChanged, self), 1500);
                        self._map.getMap().addListener('bounds_changed', debouncer);
                    });
                }
                this._map.create(bounds, locations, center, zoom);
                // this._map.removeMarkers();
            },

            /**
             * Request initial map bounds
             * @param {String} destination
             * @param {String} country
             * @param {Object} defaultCenter
             * @private
             */
            _doPreflightRequest: function (destination, country, defaultCenter) {
                const options = {method: 'POST'};
                const params = {
                    destination: destination,
                    country: country,
                    fallback_lat: defaultCenter.latitude,
                    fallback_lng: defaultCenter.longitude,
                    productSearch: this._productSearch
                };
                if (this._map) {
                    this._map.removeMarkers();
                    this._map.setIsLoading(true);
                }
                this._requestHandler.cancel(this.option('preflightRoute'));
                this._requestInProgress = true;
                this._requestHandler.send(this.option('preflightRoute'), params, {}, options);
            },

            /**
             * @param requestData
             * @private
             */
            _onPreflightRequestCancel: function (requestData) {
                if (requestData.route === this.option('preflightRoute')) {
                    this._requestInProgress = false;
                }
            },

            /**
             * Updates map viewport
             * @param {PreflightResponseEvent} event
             * @param requestData
             * @private
             */
            _onPreflightRequestSuccess: function (event, requestData) {
                if (event.state !== 'OK') {
                    return;
                }

                if (requestData.route === this.option('preflightRoute') && this._requestInProgress === true) {
                    this._requestInProgress = false;
                    this._initMap(event.meta.bounds, event.meta.locations, event.meta.center, 30);
                }
            },

            /**
             * Loads markers on bounds or zoom change
             * @private
             */
            _onBoundsZoomChanged: function () {
                this._map.loadMarkers(this._productSearch);
            }
        });

        return DynamicRegionMap;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/map/dynamicRegionMap.js